import React from 'react';
import { useApp } from '@/context/AppContext';
import { PageHeader, Card } from '@/components/common';
import { ChatPanel } from '@/components/ChatPanel';

const Advisor = () => {
  const { t } = useApp();
  return (
    <div>
      <PageHeader title={t('advisor.title')} subtitle={t('advisor.subtitle')} />
      <Card className="overflow-hidden h-[calc(100vh-15rem)] min-h-[500px]" data-testid="advisor-page">
        <ChatPanel />
      </Card>
    </div>
  );
};

export default Advisor;
